export default "__VITE_ASSET__DLfiBwQ4__"